import {
  type Purpose,
  type Size,
} from '@snack-uikit/typography/src/components/types';
import { useContext } from 'react';

import { MediaWidthContext } from '../contexts/MediaWidth/MediaContext';

enum breakpoints {
  CAROUSEL_NAVIGATION = 1340,
  XLG = 1280,
  LG = 1052,
  MD = 828,
  SM = 636,
  XSM = 435,
}

export type TypographyFrame = { purpose: Purpose; size: Size };

type Frames = {
  desktop: TypographyFrame;
  tablet: TypographyFrame;
  phone?: TypographyFrame;
};

export const useWindowWidth = () => {
  const windowWidth = useContext(MediaWidthContext);

  const getAdaptiveSizeTypography = (frames: Frames): TypographyFrame => {
    if (windowWidth) {
      if (windowWidth > breakpoints.MD) {
        return frames.desktop;
      }

      if (windowWidth > breakpoints.SM && windowWidth <= breakpoints.MD) {
        return frames.tablet;
      }

      if (windowWidth <= breakpoints.SM) {
        return frames.phone ? frames.phone : frames.tablet;
      }
    }

    return frames.desktop;
  };

  return { windowWidth, breakpoints: breakpoints, getAdaptiveSizeTypography };
};
